import { X, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

// Fixed-height (48px) sticky header for the inspector panel.

interface InspectorHeaderProps {
  icon: LucideIcon;
  title: string;
  breadcrumb: string;
  onClose: () => void;
}

export function InspectorHeader({ icon: Icon, title, breadcrumb, onClose }: InspectorHeaderProps) {
  return (
    <header
      className={cn(
        'shrink-0',
        'flex items-center gap-2',
        'h-[var(--inspector-header-height)] px-4',
        'border-b border-border-subtle bg-card',
        'sticky top-0 z-10',
      )}
    >
      <Icon className="h-5 w-5 shrink-0 text-brand-600" aria-hidden />
      <div className="flex-1 min-w-0">
        <div className="truncate text-base font-medium text-foreground leading-tight">{title}</div>
        <div className="truncate text-xs text-text-secondary leading-tight">{breadcrumb}</div>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Close inspector"
        className={cn(
          'inline-flex shrink-0 -mr-1.5 p-1.5 rounded',
          'text-text-secondary hover:text-foreground hover:bg-muted',
          'transition-colors duration-[var(--duration-fast)]',
        )}
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </header>
  );
}
